<template>
  <div class="tabs-area">
    <div class="tabs">
      <div
        class="tab"
        v-for="(tab, i) in list"
        :key="i"
        :class="{ active: props.modelValue === tab.name }"
        @click="onTabClick(tab, i)"
      >
        {{ tab.name }}
      </div>
    </div>

    <div class="tab-content">
      <slot />
      <!-- :name="props.modelValue" -->
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  list: {
    type: Array,
    required: true,
    default: () => [],
  },
  modelValue: {
    type: String,
    required: true,
  },
});
console.log("props.modelValue", props.modelValue);

const emit = defineEmits(["update:modelValue"]);

const onTabClick = (tab, i) => {
  emit("update:modelValue", tab.name);
};
</script>

<style lang="less" scoped>
.tabs-area {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
}

.tabs {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  margin: 0;
  list-style: none;
  //   background-color: #292929;
  //   border-bottom: 1px solid #ccc;
}

.tab {
  // display: flex;
  // flex-direction: row;
  // justify-content: center;
  // align-items: center;
  cursor: pointer;
  background-color: #666666;
  width: 370px;
  height: 75px;
  line-height: 75px;
  text-align: center;
  .fcf(30,#fff,600);
  .one-line-ellipsis();
}

.tab.active {
  background-color: #292929;
}
.tab ~ .tab {
  margin-left: 1px;
}
.tab:first-child {
  border-radius: 10px 0 0 0;
}
.tab:last-child {
  border-radius: 0 10px 0 0;
}

.tab-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  list-style: none;
  padding: 50px 40px 80px;
  background-color: #292929 !important;
  border-radius: 0 0 20px 20px;
  .fcf(24,#fff);
  .lh(29);
}

@media (max-width: 1024px) {
  .tabs-area {
    // border: 2px solid yellow !important;
  }
  .tabs {
    // border: 2px solid orchid !important;
  }
  .tab {
    height: 50px;
    line-height: 50px;
    .fcf(20,#fff,600) !important;
  }
  .tab-content {
    padding: 20px 5vw 40px !important;
  }
}
</style>
